<template>
  <div>
    <div class="container">
      <el-form style="margin-top: 10px" size="mini" :model="searchInfo" inline>
        <el-form-item style="margin-bottom: 0" label="录入时间:">
          <el-date-picker
            type="monthrange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM"
            v-model="searchInfo.enterDate"
            @change="getChartData"
            :picker-options="enterDateOptions"
            :clearable="false"
          >
          </el-date-picker>
          <el-popover
            placement="top"
            width="190"
            popper-class="followuppopover"
            trigger="hover"
          >
            <p class="tipck">
              录入的时间内名单漏斗数据，及各阶段数据；<br />
              录入时间最多不超过12个月
            </p>
            <div class="question" slot="reference">
              <div>?</div>
            </div>
          </el-popover>
        </el-form-item>
      </el-form>
    </div>
    <div class="class-data">
      <div class="data-in">
        <div class="title" style="font-weight: 600; margin-bottom: 11px">
          漏斗数据
        </div>
        <div class="funnel-picture">
          <div class="funnel-plot1">
            <div class="left">
              <p>名单数</p>
              <div class="line"></div>
            </div>
            <div class="picture">
              <div class="triangle1"></div>
              <div class="info">{{ pictureData.roster_num }}</div>
              <div class="triangle2"></div>
            </div>
            <div class="right">
              <div class="right-in">
                <div class="dian"></div>
                <div class="line"></div>
                <p>
                  名单诺访率：{{ pictureData.roster_visit_nuo_transform }} %
                </p>
              </div>
            </div>
          </div>
          <div class="funnel-plot1">
            <div class="left l1">
              <p>已联络</p>
              <div class="line"></div>
            </div>
            <div class="picture bgc1">
              <div class="triangle1"></div>
              <div class="info">{{ pictureData.connected_num }}</div>
              <div class="triangle2"></div>
            </div>
            <div class="right r1">
              <!-- 注释占位，待以后的版本确认后，再添加xxx率 -->
              <div class="right-in">
                <!-- <div class="dian"></div>
                <div class="line"></div>
                <p>xxx率： %</p> -->
              </div>
            </div>
          </div>
          <div class="funnel-plot1">
            <div class="left l2">
              <p>诺访</p>
              <div class="line"></div>
            </div>
            <div class="picture bgc2">
              <div class="triangle1"></div>
              <div class="info">{{ pictureData.committed_to_visit_num }}</div>
              <div class="triangle2"></div>
            </div>
            <div class="right r2">
              <div class="right-in">
                <div class="dian"></div>
                <div class="line"></div>
                <p>诺访到访率：{{ pictureData.visit_nuo_transform }} %</p>
              </div>
            </div>
          </div>
          <div class="funnel-plot1">
            <div class="left l3">
              <p>已到访</p>
              <div class="line"></div>
            </div>
            <div class="picture bgc3">
              <div class="triangle1"></div>
              <div class="info">{{ pictureData.visited_num }}</div>
              <div class="triangle2"></div>
            </div>
            <div class="right r3">
              <div class="right-in">
                <div class="dian"></div>
                <div class="line"></div>
                <p>到访转化率： {{ pictureData.visit_transform }} %</p>
              </div>
            </div>
          </div>
          <div class="funnel-plot1">
            <div class="left l4">
              <p>已转化</p>
              <div class="line"></div>
            </div>
            <div class="picture bgc4">
              <div class="triangle1"></div>
              <div class="info">{{ pictureData.transformed_num }}</div>
              <div class="triangle2"></div>
            </div>
            <div class="right r4"></div>
          </div>
        </div>
      </div>
      <div class="data-in">
        <div class="container data-chart">
          <div class="selfheader">
            <div style="font-size: 14px; font-weight: 600">综合数据</div>
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">录入时间内的意向学员名单数，至今各阶段数据；</p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
          <div class="datas" v-for="(item, index) in dataList" :key="index">
            <div class="list-title">
              <p>
                {{ item.title }}
              </p>
              <el-popover
                placement="top"
                width="250"
                popper-class="followuppopover"
                trigger="hover"
              >
                <div class="tipck" v-if="item.n === 1">
                  <p>{{ item.popover1 }}</p>
                  <p>{{ item.popover2 }}</p>
                </div>
                <div class="tipck" v-if="item.n === 2">
                  <p>{{ item.popover3 }}</p>
                  <p>{{ item.popover4 }}</p>
                  <p>{{ item.popover5 }}</p>
                  <p>{{ item.popover6 }}</p>
                  <p>{{ item.popover7 }}</p>
                </div>
                <div class="tipck" v-if="item.n === 3">
                  <p>{{ item.popover8 }}</p>
                  <p>{{ item.popover9 }}</p>
                  <p>{{ item.popover10 }}</p>
                  <p>{{ item.popover11 }}</p>
                </div>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
            <div class="data-item">
              <div
                :class="it.route_name !== '' ? 'item high-light' : 'item'"
                v-for="(it, ind) in item.arr"
                :key="ind"
              >
                <div class="item-top">
                  <p>{{ it.name }}</p>
                </div>
                <div class="item-bottom">{{ it.num }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 数据明细 -->
    <div class="container">
      <div class="cont-form">
        <el-form :model="searchInfo" label-width="80px" inline size="mini">
          <div style="font-size: 14px; display: inline-block; margin-top: 7px">
            数据明细
          </div>
          <el-form-item label="查询时间">
            <el-date-picker
              v-model="searchInfo.query_time"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              @change="handleSearch"
              :picker-options="executeTimeOptions"
              :clearable="false"
            >
            </el-date-picker>
            <el-popover
              placement="top"
              width="230"
              popper-class="followuppopover"
              trigger="hover"
            >
              <div class="tipck">
                录入时间内的名单数，截止到查询时间各阶段数据明细
              </div>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchInfo.region"
              placeholder="高级筛选"
              clearable
              @change="handleSearch"
            >
              <el-option label="课程顾问" :value="1"></el-option>
              <el-option label="出现方式" :value="2"></el-option>
              <el-option label="来源渠道" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="staff_id" v-show="searchInfo.region === 1">
            <common-staff-pull-down
              :originId.sync="searchInfo.staff_id"
              :jobIds="[3]"
              @change="handleSearch"
            ></common-staff-pull-down>
          </el-form-item>
          <el-form-item prop="studentApp_id" v-show="searchInfo.region === 2">
            <el-select
              v-model="searchInfo.studentApp_id"
              clearable
              placeholder="请选择"
              @change="handleSearch"
            >
              <el-option
                v-for="item in studentAppearList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="source_id" v-show="searchInfo.region === 4">
            <el-select
              v-model="searchInfo.source_id"
              clearable
              placeholder="请选择"
              @change="handleSearch"
            >
              <el-option
                v-for="item in sourceList"
                :key="item.source_id"
                :label="item.name"
                :value="item.source_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div style="min-height: 240px">
        <div class="tabs">
          <div
            :class="checkTabs === 1 ? 'tabs-in p1 check-tabs' : 'tabs-in p1 '"
            @click="checkTabs = 1"
          >
            综合数据
          </div>
          <div
            :class="checkTabs === 2 ? 'tabs-in check-tabs' : 'tabs-in '"
            @click="checkTabs = 2"
          >
            课程顾问
          </div>
          <div
            :class="checkTabs === 3 ? 'tabs-in check-tabs' : 'tabs-in '"
            @click="checkTabs = 3"
          >
            出现方式
          </div>
          <div
            :class="checkTabs === 4 ? 'tabs-in p2 check-tabs' : 'tabs-in p2'"
            @click="checkTabs = 4"
          >
            来源渠道
          </div>
        </div>
        <comprehensive-table v-if="checkTabs === 1" :data="searchData">
        </comprehensive-table>
        <course-table v-if="checkTabs === 2" :data="searchData"> </course-table>
        <appear-table v-if="checkTabs === 3" :data="searchData"></appear-table>
        <channel-table
          v-if="checkTabs === 4"
          :data="searchData"
        ></channel-table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import { marketFunnelApi } from "@/api/statistics";
import { dateFormat, getCurrentMonth } from "@/utils/timeFormat";
import comprehensiveTable from "./comprehensive.vue";
import appearTable from "./appear.vue";
import channelTable from "./channel.vue";
import courseTable from "./course.vue";
import { roundNumbers } from "@/utils/roundNumbers";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";

export default {
  components: {
    comprehensiveTable,
    appearTable,
    channelTable,
    courseTable,
    commonStaffPullDown,
  },
  data() {
    return {
      searchInfo: {
        enterDate: [],
        query_time: "",
      },
      dataList: [],
      searchData: {},
      checkTabs: 1,
      start: "",
      end: "",
      studentAppearList: [],
      sourceList: [],
      pictureData: {}, // 漏斗图表
      executeTimeOptions: {
        disabledDate: (time) => {
          if (this.searchInfo.start_time && this.searchInfo.end_time) {
            return (
              time.getTime() <
                new Date(this.searchInfo.start_time).getTime() -
                  1 * 24 * 60 * 60 * 1000 ||
              time.getTime() > new Date().getTime()
            );
            //这里是查询时间的选择不可以小于录入时间的开始时间和今天时间
          }
        },
      },
      choiceDate0: "",
      enterDateOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = "";
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() - 11
          );
          const maxTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() + 11
          );
          const min = minTime;
          const newDate =
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1;
          const max = newDate < maxTime ? newDate : maxTime;
          //如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          //若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        },
      },
    };
  },
  created() {
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
    }).then((res) => {
      if (res.error_code === 0) {
        this.studentAppearList = res.data.list;
      }
    });
    sourceTypeSelectListApi().then((res) => {
      if (res.error_code === 0) {
        this.sourceList = res.data.list;
      }
    });
    this.getMonthTime();
    this.searchInfo.query_time = dateFormat("YYYY-mm-dd", new Date());
  },
  async beforeMount() {
    await this.getList({
      start_time: this.searchInfo.start_time,
      end_time: this.searchInfo.end_time,
    });
  },
  methods: {
    getList(time) {
      marketFunnelApi({
        start_time: time.start_time,
        end_time: time.end_time,
      }).then((res) => {
        if (res.error_code === 0) {
          this.dataList = [];
          const d = res.data;
          d.roster_visit_nuo_transform = roundNumbers(
            d.roster_visit_nuo_transform
          );
          d.visit_nuo_transform = roundNumbers(d.visit_nuo_transform);
          d.visit_transform = roundNumbers(d.visit_transform);
          this.pictureData = d;
          const stageArr = {
            title: "阶段数据",
            popover3: "诺访: 诺访状态的意向学员，按名单人数去重统计；",
            popover4: "已到访: 已到访状态的意向学员，按名单人数去重统计；",
            popover6: "已转化：已转化状态的意向学员，按名单人数去重统计；",
            popover7: "订单金额：已转化为在读学员的有效订单金额统计；",
            n: 2,
            arr: [
              {
                name: "诺访",
                num: d.committed_to_visit_num,
                route_name: "follow",
                key: 3,
              },
              {
                name: "已到访",
                num: d.visited_num,
                route_name: "follow",
                key: 4,
              },
              {
                name: "已转化",
                num: d.transformed_num,
                route_name: "follow",
                key: 6,
              },
              {
                name: "订单金额",
                num: roundNumbers(d.order_amount),
                route_name: "",
                key: "",
              },
            ],
          };
          const transformArr = {
            title: "转化率",
            popover8: "名单诺访率 = 诺访数 / 名单数 * 100%；",
            popover9: "诺访到访率 = 已到访数 / 诺访数 * 100%；",
            popover10: "到访转化率 = 已转化数 / 已到访数 * 100%；",
            popover11: "名单转化率 = 已转化数 / 名单数 * 100%",
            n: 3,
            arr: [
              {
                name: "名单诺访率",
                num: roundNumbers(d.roster_visit_nuo_transform) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "诺访到访率",
                num: roundNumbers(d.visit_nuo_transform) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "到访转化率",
                num: roundNumbers(d.visit_transform) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "名单转化率",
                num: roundNumbers(d.roster_transform) + "%",
                route_name: "",
                key: "",
              },
            ],
          };
          this.dataList.push(stageArr, transformArr);
        }
      });
    },
    getChartData() {
      const monthStartArr = getCurrentMonth(this.searchInfo.enterDate[0]);
      const monthEndArr = getCurrentMonth(this.searchInfo.enterDate[1]);
      const start = dateFormat("YYYY-mm-dd", monthStartArr[0]);
      const end = dateFormat("YYYY-mm-dd", monthEndArr[1]);
      this.searchInfo.start_time = start;
      this.searchInfo.end_time = end;
      this.getList({
        start_time: this.searchInfo.start_time,
        end_time: this.searchInfo.end_time,
      });
      this.searchData = this.searchInfo;
    },
    handleSearch() {
      this.searchData = this.searchInfo;
    },
    getMonthTime() {
      const now = new Date();
      const monthArr = getCurrentMonth(now.getTime());
      this.start = dateFormat("YYYY-mm-dd", monthArr[0]);
      this.end = dateFormat("YYYY-mm-dd", monthArr[1]);
      this.searchInfo.enterDate[0] = this.start.slice(0, 7);
      this.searchInfo.enterDate[1] = this.end.slice(0, 7);
      this.getChartData();
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 15px;
  .cont-form {
    margin-top: 20px;
  }
}
.class-data {
  display: flex;
  width: 100%;
  .data-in {
    height: 222px;
    width: 49%;
    background-color: #ffffff;
    padding: 0 12px 12px 12px;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 15px;
    &:last-child {
      margin-left: 15px;
    }
    .title {
      font-size: 14px;
      font-weight: 500;
      color: #5c5d5e;
      margin: 14px 12px;
    }
    .funnel-picture {
      padding: 0 24px;
      .funnel-plot1 {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
        .left {
          width: 90px;
          height: 30px;
          display: flex;
          align-items: center;
          p {
            width: 36px;
            font-size: 12px;
            color: #5c5d5e;
            margin-right: 22px;
            white-space: nowrap;
          }
          .line {
            flex: 1;
            height: 1px;
            border-bottom: 1px dashed #d8d8d8;
          }
        }
        .picture {
          max-width: 271px;
          flex: 1;
          height: 30px;
          display: flex;
          background: #d9f6ee;
          justify-content: space-between;
          .triangle1 {
            width: 0;
            height: 0;
            border-color: transparent #ffffff; /*上下颜色 左右颜色*/
            border-width: 30px 0 0 18px;
            border-style: solid;
          }
          .info {
            flex: 1;
            font-size: 18px;
            font-weight: 600;
            text-align: center;
            color: #5c5d5e;
            line-height: 30px;
          }
          .triangle2 {
            width: 0;
            height: 0;
            border-color: transparent #ffffff; /*上下颜色 左右颜色*/
            border-width: 30px 18px 0 0;
            border-style: solid;
          }
        }
        .right {
          height: 30px;
          width: 175px;
          .right-in {
            display: flex;
            align-items: center;
            position: relative;
            left: 0;
            bottom: -25px;
            .dian {
              width: 8px;
              height: 8px;
              background: #07d1aa;
              border-radius: 50%;
              margin-right: 10px;
            }
            .line {
              flex: 1;
              height: 1px;
              border-bottom: 1px dashed #d8d8d8;
            }
            p {
              width: 118px;
              margin-left: 10px;
              font-size: 12px;
              color: #5c5d5e;
              white-space: nowrap;
            }
          }
        }
        .l1 {
          width: 110px !important;
        }
        .r1 {
          width: 195px !important;
        }
        .bgc1 {
          max-width: 234px !important;
          background: #abebd9 !important;
        }
        .l2 {
          width: 130px !important;
        }
        .r2 {
          width: 215px !important;
        }
        .bgc2 {
          max-width: 195px !important;
          background: #73e0c4 !important;
        }
        .l3 {
          width: 150px !important;
        }
        .r3 {
          width: 235px !important;
        }
        .bgc3 {
          max-width: 159px !important;
          background: #52dcb9 !important;
        }
        .l4 {
          width: 170px !important;
        }
        .r4 {
          width: 255px !important;
        }
        .bgc4 {
          max-width: 119px !important;
          background: #52dcb9 !important;
        }
      }
    }
    .container {
      background-color: #ffffff;
      padding: 0 12px 12px 12px;
      border-radius: 4px;
      overflow: hidden;
      color: #5c5d5e;
      .cont-form {
        margin-top: 20px;
      }
      .selfheader {
        padding-top: 14px;
        display: flex;
        align-items: center;
      }
      .datas {
        margin: 10px 0;
        margin-left: 22px;
        .list-title {
          display: flex;
          align-items: center;
          font-size: 12px;
          margin-bottom: 10px;
          width: 100px;
        }
        .data-item {
          flex: 1;
          height: 55px;
          width: 100%;
          display: flex;
          .item {
            padding: 10px;
            text-align: center;
            box-sizing: border-box;
            width: 103px;
            background: #f6fafc;
            border-right: 1px solid #f1f2f2;
            &:last-child {
              border-right: none;
            }
            .item-top {
              margin-bottom: 5px;
              font-size: 12px;
            }
            .item-bottom {
              font-size: 18px;
              font-weight: 700;
            }
          }
        }
      }
      .tabs {
        display: flex;
        margin-bottom: 15px;
        .tabs-in {
          border: 1px solid #c0c7ce;
          color: #5c5d5e;
          padding: 5px 15px;
          cursor: pointer;
          border-right: 0;
          &:last-child {
            border-right: 1px solid #c0c7ce;
          }
        }
        .p1 {
          border-radius: 3px 0 0 3px;
        }
        .p2 {
          border-radius: 0 3px 3px 0;
        }
      }
    }
  }
}
.question {
  display: inline-block;
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.tabs {
  display: flex;
  margin-bottom: 15px;
  .tabs-in {
    border: 1px solid #c0c7ce;
    color: #5c5d5e;
    padding: 5px 15px;
    cursor: pointer;
    border-right: 0;
    &:last-child {
      border-right: 1px solid #c0c7ce;
    }
  }
  .p1 {
    border-radius: 3px 0 0 3px;
  }
  .p2 {
    border-radius: 0 3px 3px 0;
  }
}
.check-tabs {
  border-color: #07d1aa !important;
  color: #07d1aa !important;
  & + .tabs-in {
    border-left: 1px solid #07d1aa !important;
  }
}
v-deep canvas {
  position: absolute;
  left: -159px;
  top: -68px;
  width: 300px;
  height: 264px;
}
</style>
